import { all } from 'redux-saga/effects';

import consultaReabilitacaoSaga from './consultaReabilitacao/saga';

export default all([consultaReabilitacaoSaga]);
